import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UnidadMedidaModel } from '@shared/models/unidad-medida-model';
import { KeyValueOption } from '@shared/table';
import {
  CategoriaNegocio,
  Ciudad,
  Departamento,
  Pais,
  TipoNegocio,
  TipoSociedad,
} from './yalo-data-access.types';
import { EstablecimientosService } from '../services';
import { take } from 'rxjs/operators';

@Injectable()
export class YaloDataAccessService {
  constructor(
    private http: HttpClient,
    private establecimientosService: EstablecimientosService
  ) {}

  tipoSociedades$ = this.http.get<TipoSociedad[]>(
    `${environment.API_URL}/TipoSociedades`
  );

  tipoNegocios$ = this.http.get<TipoNegocio[]>(
    `${environment.API_URL}/TipoNegocios`
  );

  paises$ = this.http.get<Pais[]>(`${environment.API_URL}/Paises`);

  getDepartamentos(CodPais: number) {
    return this.http.get<Departamento[]>(
      `${environment.API_URL}/Departamentos/${CodPais}`
    );
  }

  getCiudades(CodDepartamento: number) {
    return this.http.get<Ciudad[]>(
      `${environment.API_URL}/Ciudades/${CodDepartamento}`
    );
  }

  getCategoriaNegocios(CodTipoNegocio: number) {
    return this.http.get<CategoriaNegocio[]>(
      `${environment.API_URL}/CategoriaNegocios/${CodTipoNegocio}`
    );
  }

  getEstablecimientos() {
    return this.establecimientosService.establecimientos$.pipe(take(1));
  }

  getEstablecimientosBodegas() {
    return this.establecimientosService.getMisEstablecimientosBodegas();
  }
  
  // TODO: Move to products data access
  getCategoriasProductosTable() {
    return this.http.get<KeyValueOption[]>(
      `${environment.API_URL}/TableCategoriasProductos`
    );
  }

  // TODO: Move to products data access
  getCategoriasMateriaPrimaTable() {
    return this.http.get<KeyValueOption[]>(
      `${environment.API_URL}/TableCategoriasMateriaPrima`
    );
  }

  // TODO: Move to products data access
  getDescuentosTable() {
    return this.http.get<KeyValueOption[]>(
      `${environment.API_URL}/TableDescuentos`
    );
  }

  // TODO: Move to products data access
  getImpuestosTable() {
    return this.http.get<KeyValueOption[]>(
      `${environment.API_URL}/TableImpuestos`
    );
  }

  // TODO: Move to products data access
  getMarcasTable() {
    return this.http.get<KeyValueOption[]>(
      `${environment.API_URL}/TableMarcas`
    );
  }

  // TODO: Move to products data access
  getPresentacionesTable() {
    return this.http.get<KeyValueOption[]>(
      `${environment.API_URL}/TablePresentaciones`
    );
  }

  // TODO: Move to products data access
  getAgregadores() {
    return this.http.get<any>(
      `${environment.API_URL}/ProductosUtilidades/Agregadores`
    );
  }

  // TODO: Move to products data access
  getUnidadesMedidasTable() {
    return this.http.get<UnidadMedidaModel[]>(
      `${environment.API_URL}/TableUnidadesMedidas`
    );
  }
}
